import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { BiSafeUrlPipe } from '../../../../projects/shared-lib/src/lib/pipe';

@Component({
    selector: 'tw-template-view-seat',
    imports: [BiSafeUrlPipe],
    template: `
        @if (viewImageUrl()) {

            <div
                class="seat-image-panel"
                style="
                margin-top: 16px;
                padding: 16px;
                border: 1px solid var(--mat-sys-outline-variant);
                border-radius: 8px;
                background: var(--mat-sys-surface);
              ">
                @if (isIframeUrl(viewImageUrl())) {
                
                    <div style="position: relative; width: 100%; height: 200px; border-radius: 4px; overflow: hidden;">
                        @if (iframeLoading()) {
                            <div
                                style="
                      position: absolute; inset: 0;
                      display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px;
                      background: var(--mat-sys-surface-variant, #f0f0f0);
                      border-radius: 4px;
                      z-index: 1;
                    ">
                                <div
                                    style="
                        width: 32px; height: 32px;
                        border: 3px solid var(--mat-sys-outline-variant, #ccc);
                        border-top-color: var(--primaryBackground, #1976d2);
                        border-radius: 50%;
                        animation: spin 0.8s linear infinite;
                      "></div>
                                <span style="font-size: 12px; color: var(--mat-sys-on-surface-variant, #666);">Chargement…</span>
                            </div>
                        }
                        <iframe
                            [src]="viewImageUrl() | biSafeUrl"
                            style="width: 100%; height: 200px; border: none; border-radius: 4px; display: block;"
                            [style.opacity]="iframeLoading() ? 0 : 1"
                            sandbox="allow-scripts allow-same-origin"
                            (load)="iframeLoading.set(false)"></iframe>
                    </div>
                } @else {
                    <img
                        [src]="viewImageUrl()"
                        alt="Vue du siège"
                        style="max-width: 100%; height: 200px; border-radius: 4px; display: block" />
                }
            </div>
        }
    `,
    styles: [
        `
            @keyframes spin {
                to {
                    transform: rotate(360deg);
                }
            }
        `,
    ],
    styleUrls: ['./template-view-seat.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateViewSeat {
    viewImageUrl = input<string>('');
    readonly iframeLoading = signal(false);

    constructor() {
        effect(() => {
            const url = this.viewImageUrl();
            if (url && this.isIframeUrl(url)) {
                this.iframeLoading.set(true);
            }
        });
    }

    isIframeUrl(url?: string): boolean {
        if (!url) return false;
        return url.includes('iframe=true');
    }
}
